import { render, staticRenderFns } from "./PurchaseRequisitionList.vue?vue&type=template&id=03a5c4a2"
import script from "./PurchaseRequisitionList.vue?vue&type=script&lang=js"
export * from "./PurchaseRequisitionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports